import React, { useEffect, useState } from "react";
import NodeNameValidation from "../../atoms/node-name-validation";
import { Form, FormGroup, Label, Input, Row, Col, Card } from "reactstrap";
import { cloneDeep } from "lodash";
import HelpTooltip from "../../atoms/help-tooltip";
import { t } from "../../../utils/utils";
import T from "../../atoms/translate";
export default function NodeThrowErrorProperty({
  node,
  nodeChange,
  dependencies
}) {
  const [message, setMessage] = useState("");
  const [code, setCode] = useState(0);
  useEffect(() => {
    const { args } = node.properties;
    if (args) {
      if (args.message) {
        setMessage(args.message.value);
        if (args.message.code) {
          setCode(args.message.code);
        }
      }
    }
  }, [node]);
  const onSubmit = name => {
    const tmp = cloneDeep(node);
    tmp.properties.name = name;
    if (message != null && code != null) {
      tmp.properties.args.message = { value: message, code: code };
    }
    return nodeChange(tmp);
  };
  return (
    <>
      <NodeNameValidation
        label={t("modalPropiedadesLabelNodoValidacionNombre")}
        feedback={t("modalPropiedadesFeedbackValidacionNombre")}
        nodesNames={dependencies.nodeNames}
        oldName={node.properties.name}
        onSubmit={onSubmit}
      />
      <Card body className="border-0 box-shadow mb-4">
        <Row>
          <Col xs="12">
            <h1 className="font-size-09 text-secondary fw-600 text-uppercase">
              <T i18nKey="modalPropiedadesErrorTitulo" />
            </h1>
          </Col>
          <Col xs="12" className="px-0">
            <Form>
              <Row>
                <Col xs="12" md="6">
                  <FormGroup>
                    <Label md={12}>
                      <T i18nKey="modalPropiedadesErrorCodigo" />{" "}
                      <HelpTooltip
                        msg={t("modalPropiedadesErrorCodigoTooltip")}
                      />
                    </Label>
                    <Col md={12}>
                      <Input
                        type="number"
                        value={code}
                        onChange={e => setCode(e.target.value)}
                      />
                    </Col>
                  </FormGroup>
                </Col>
                <Col xs="12" md="6">
                  <FormGroup>
                    <Label md={12}>
                      <T i18nKey="modalPropiedadesErrorMensaje" />{" "}
                      <HelpTooltip
                        msg={t("modalPropiedadesErrorMensajeTooltip")}
                      />
                    </Label>
                    <Col md={12}>
                      <Input
                        type="textarea"
                        value={message}
                        onChange={e => setMessage(e.target.value)}
                      />
                    </Col>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Card>
    </>
  );
}
